import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { HomePage } from '@/components/infoPages/HomePage'
import { withPublicPageSeo } from '@/modules/seo'

const searchSchema = z.object({
  token: z.string().optional(),
  atoken: z.string().optional(),
})

const HomePageWithSeo = withPublicPageSeo('home', HomePage)

export const Route = createFileRoute('/')({
  component: HomePageWithSeo,
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    const inviteToken = search.token ?? search.atoken
    if (inviteToken) {
      throw redirect({
        to: '/auth/invite',
        search: { token: inviteToken },
      })
    }
  },
})
